import React, { useRef, useEffect } from 'react';
import { string, shape, number } from 'prop-types';
import { Video, PopupImage, ImageContainer, ImageWrapper } from './media-container.styles';

const MediaContainer = ({
  media,
  alt,
  currentSlide,
  index
}) => {
  const videoRef = useRef(null);
  useEffect(() => {
    if (videoRef.current && currentSlide !== index) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  }, [currentSlide, index]);
  return /*#__PURE__*/React.createElement(ImageContainer, null, media.mediaType === 'image' ? /*#__PURE__*/React.createElement(ImageWrapper, null, /*#__PURE__*/React.createElement(PopupImage, {
    alt: alt,
    lazy: true,
    src: media.mediaUrl
  })) : /*#__PURE__*/React.createElement(Video, {
    ref: videoRef,
    muted: true,
    controls: true,
    type: "video/mp4",
    src: media.mediaUrl,
    disablePictureInPicture: true,
    controlsList: "nodownload noplaybackrate"
  }));
};

process.env.NODE_ENV !== "production" ? MediaContainer.propTypes = {
  media: shape({
    mediaUrl: string,
    mediaType: string
  }),
  alt: string,
  currentSlide: number,
  index: number
} : void 0;
export default MediaContainer;